import React from 'react';
import classNames from 'classnames';
import moment from 'moment';

import { Link } from 'gatsby';


export class Block extends React.Component {
  constructor (props) {
    super(props);
    this.state = {};
  }

  get className () {
    return classNames({
      'block': true
    });
  }  

  render () {
    return (
      <Link className={ this.className } to={ this.props.slug }>
        <div className="block__overlay block__overlay--top" />
        <div className="block__content">
          <div className="block__head">
            <div className="block__head__left">{ this.props.title }</div>
            <div className="block__head__right">
            { moment(this.props.date).format('DD.MM.YYYY') }<br/>
            </div>
          </div>
          { this.props.image && <div className="block__image" style={{ backgroundImage: `url(${this.props.image}?w=600)` }} /> }
        </div>
        <div className="block__overlay">
          <div>{ this.props.excerpt }</div>
        </div>
      </Link>
    );
  }
}
